import { r as reloadScripts } from "./utils-D8tYCXRD.js";
const replacePersonalCansSection = (cart) => {
  const isPersonalisedProductPage = document.querySelector(
    ".product__personalised"
  );
  console.warn("isPersonalisedProductPage", isPersonalisedProductPage);
  if (!isPersonalisedProductPage) {
    return;
  }
  const hasPersonalisedProduct = cart.items.some(
    (item) => item.properties._proof
  );
  console.warn("hasPersonalisedProduct", hasPersonalisedProduct);
  const getMarkup = async () => {
    var _a, _b, _c;
    const section = await fetch(`?section_id=product-personalised`);
    const sectionString = await section.text();
    console.warn("SECTION String", sectionString);
    const parser = new DOMParser();
    const doc = parser.parseFromString(sectionString, "text/html");
    console.warn("DOC", doc);
    const oldSection = (_a = isPersonalisedProductPage == null ? void 0 : isPersonalisedProductPage.parentElement) == null ? void 0 : _a.parentElement;
    console.warn("oldSection", oldSection);
    const newSection = (_c = (_b = doc.querySelector(".product__personalised")) == null ? void 0 : _b.parentElement) == null ? void 0 : _c.parentElement;
    console.warn("newSection", newSection);
    if (oldSection && newSection) {
      console.warn("REPLACING PC CANS SECTION");
      oldSection.innerHTML = newSection.innerHTML;
      console.warn("RELOADING SCRIPTS");
      reloadScripts(oldSection);
    }
  };
  if (isPersonalisedProductPage) {
    getMarkup();
  }
};
export {
  replacePersonalCansSection as r
};
